import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes", "className", "children"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { default as withStyles } from '../styles';
import { spacing30 } from '../styles/tokens';
export var styles = function styles(theme) {
  return {
    root: {
      '& button': {
        margin: "0 " + spacing30,
        marginBottom: spacing30
      }
    }
  };
};
/**
 * Use a `ButtonGroup` for two or more buttons that are grouped together.
 */

var ButtonGroup = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var classes = props.classes,
      className = props.className,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, _excluded); // showcase all class overrides


  var buttonGroupClasses = classNames(classes.root, className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: buttonGroupClasses
  }, rest, {
    ref: ref
  }), children);
});
ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.propTypes = {
  /**
   * Class name to assign the component.
   */
  className: PropTypes.string,

  /**
   * Classes used to extend original style object.
   */
  classes: PropTypes.object,

  /**
   * The buttons that are passed in as children within ButtonGroups.
   */
  children: PropTypes.node.isRequired
};
export default withStyles(styles)(ButtonGroup);